<div class="eiq-header-basic-details">
  <mat-toolbar>
    <eiq-button [text]="'Go back'" [icon]="faArrowLeft" color="primary" [style]="'basic'" [size]="'small'" (clicked)="back.emit()"></eiq-button>
  </mat-toolbar>

  <div class="eiq-header-basic-details__sub">
    <ng-content select="[slot=subHeader]"></ng-content>
  </div>

</div>
